import { useGetTranslation } from "components/Translations/translationUtils";
import { useMemo } from "react";

type ArgType = {
	filterValue: string | undefined
	remainingItems: any[]
	getItemText(item: any): string
	sort?: boolean
}

export const useFilteredItems = ({ filterValue, remainingItems, getItemText, sort }: ArgType) => {
	const getTranslation = useGetTranslation();

	return useMemo(
		() => {
			const value = filterValue ? filterValue.toLowerCase() : '';

			let filteredItems = remainingItems.filter((item) => {
				const text = getTranslation(getItemText(item));
				return text?.toLowerCase().includes(value);
			})
			// sort by alphabet
			if (sort) {
				filteredItems = filteredItems.sort((a, b) => {
					const textA = getTranslation(getItemText(a))?.toUpperCase() || '';
					const textB = getTranslation(getItemText(b))?.toUpperCase() || ''
					if (textA < textB) {
						return -1;
					}
					if (textA > textB) {
						return 1;
					}
					return 0;
				})
			}

			return filteredItems;
		},
		[filterValue, remainingItems, sort, getTranslation, getItemText]
	)
}
